/**
 * this is added for https://wandb.atlassian.net/browse/WB-16553
 * number chosen is non-scientific, so may be able to be adjusted
 */
export const MAX_VISIBLE_LINE_LENGTH = 5000;
export const DEFAULT_LINE_HEIGHT = 22;
export const COMPACT_LINE_HEIGHT = 16; // applied if there are no timestamps or labels displayed
export const TRUNCATED_LABEL_MAX_CHARS = 16;
export const REGEX_RUN_ID =
  /WANDB_PROJECT='(.*)'.*WANDB_ENTITY=([a-z0-9\-_]*).*WANDB_RUN_ID=([a-z0-9]+)/;
export const UNLABELED = 'Unlabeled';
export const OUTER_PADDING = 16;
// Virtuoso requires a stable (logical) index for log lines as new ones get
// prepended so that the scroll position doesn't move. The library recommends
// [1] this be accomplished by setting the first item index to some arbitrarily
// large number, which becomes the maximum number of logs that can be displayed.
// For now, a number sufficiently larger than the storage limit for run logs [2]
// will be used.
//
// [1] https://github.com/petyosi/react-virtuoso/discussions/1032#discussioncomment-8261348
// [2] https://github.com/wandb/core/blob/37a5823d7a9316fe82faaa9e7e257e94d99d0a54/services/gorilla/internal/runupdates/run_updater.go#L29
export const FIRST_ITEM_INDEX_INITIAL = 1_000_000;
